const styles = theme => ({
  root: {
    marginTop: 16,
    marginBottom: 16,
    maxWidth: "100%"
  },
  wrapper: {
    width: "100%",
    background: "#fff"
  },
  wrapperFill: {
    flex: 1,
    minHeight: 0,
    display: "flex",
    flexDirection: "column"
  },
  centred: {
    width: "100%",
    maxWidth: "1320px",
    alignSelf: "center",
    marginLeft: "auto",
    marginRight: "auto"
  },
  centredFill: {
    flex: 1,
    minHeight: 0,
    display: "flex",
    flexDirection: "column"
  },
  centred2: {
    width: "100%",
    maxWidth: "920px",
    alignSelf: "center",
    marginLeft: "auto",
    marginRight: "auto"
  },
  content: {
    background: "#fff"
  },
  contentFill: {
    flex: 1,
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    padding: "16px 0"
  },
  bodyFill: {
    flex: 1,
    minHeight: 0,
    display: "flex",
    flexDirection: "column"
  },
  bodyFillScroll: {
    overflowY: "auto",
    overflowX: "hidden"
  },
  flex: {
    flex: 1
  },
  rootFill: {
    height: "100%",
    minHeight: 0,
    marginTop: 0,
    marginBottom: 0
  },
  gridItemFill: {
    height: "100%",
    minHeight: 0,
    display: "flex",
    flexDirection: "column"
  },
  gridItemScroll: {
    overflowY: "auto",
    overflowX: "hidden"
  },
  panel: {
    background: "#efefef"
  },
  context: {
    background: "#efefef"
  },
  contextMenu: {
    maxWidth: 100
  },
  white: {
    color: "#fff"
  }
});

export default styles;
